export default "__VITE_ASSET__Dk3R4yMW__"